import styled from 'styled-components';

export const WrapperMaps = styled.div.attrs({
  className: "WrapperMaps"
})``
